import TrelloBoard from './components/TrelloBoard'
import './App.css'

function App() {
  return (
    <div className="App">
    <TrelloBoard />
    </div>
  )
}

export default App
